import { TGlobalStore } from '..'
import { IResponsePlanAccessForm } from 'models/response.plan.model'
import type { StoreApi } from 'zustand'

export interface IResponsePlanState {
  loggedOutResponsePlan: false
  accessResponsePlanData: IResponsePlanAccessForm | undefined
  setAccessResponsePlanData: (IResponsePlanAccessForm) => void
  setLoggedOutResponsePlan: (boolean) => void
  responsePlanAlertDismissed: boolean
  setResponsePlanAlertDismissed: (boolean) => void
}

const responsePlanSlice = (set: StoreApi<TGlobalStore>['setState']): IResponsePlanState => ({
  loggedOutResponsePlan: false,
  accessResponsePlanData: undefined,
  setAccessResponsePlanData: accessResponsePlanData =>
    set(state => ({ ...state, accessResponsePlanData })),
  setLoggedOutResponsePlan: loggedOutResponsePlan =>
    set(state => ({ ...state, loggedOutResponsePlan })),
  responsePlanAlertDismissed: false,
  setResponsePlanAlertDismissed: responsePlanAlertDismissed =>
    set(state => ({ ...state, responsePlanAlertDismissed })),
})

export default responsePlanSlice
